import { call, put } from 'redux-saga/effects';

import { api, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateDockCarrierActions } from 'store/ducks/settings/dock-carrier';

export function* createDockCarrierRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/dock-carriers`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateDockCarrierActions.success(data));
    notify('success', 'Transportadora cadastrada com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateDockCarrierActions.failure(errorMessage));
  }
}
